// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"ace761acf8b08899af13","339":"fa55cd8e4a345c6a0df5"}[chunkId] + ".js";
};